import { render, staticRenderFns } from "./PopupBanners.vue?vue&type=template&id=c50df082"
import script from "./PopupBanners.vue?vue&type=script&lang=js"
export * from "./PopupBanners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports